"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpStudentsDetailsHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
var DpTableDropdownFilter_1 = require("../../TableDropdownFilter/DpTableDropdownFilter");
var DpStudentsDetailsHeader_styled_1 = require("./DpStudentsDetailsHeader.styled");
var DpStudentsDetailsHeader = function (_a) {
    var title = _a.title, _b = _a.highlight, highlight = _b === void 0 ? true : _b, totalStudents = _a.totalStudents;
    // --------------------------- State
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var options = [
        {
            id: 'no-highlight',
            title: 'No highlight',
        },
        {
            id: 'incorrect',
            title: 'Incorrect',
            selected: true,
        },
        {
            id: 'correct',
            title: 'Correct',
        },
    ];
    // --------------------------- Methods
    var filter = function (selectedOption) {
        resetSelectedOptions();
        selectedOption.selected = true;
    };
    var resetSelectedOptions = function () { return options.forEach(function (option) { return (option.selected = false); }); };
    // --------------------------- Render
    return ((0, jsx_runtime_1.jsxs)(DpStudentsDetailsHeader_styled_1.StyledStudentsDetailsHeader, { "data-testid": "student-details-header", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h1", { className: "h4", children: title }), !(0, isUndefined_1.default)(totalStudents) && ((0, jsx_runtime_1.jsxs)("span", { className: "total-students", children: [totalStudents, " ", t('studentsDetails.total')] }))] }), highlight && ((0, jsx_runtime_1.jsxs)("div", { className: "filter", children: [(0, jsx_runtime_1.jsxs)("span", { children: [t('studentsDetails.highlight'), ":"] }), (0, jsx_runtime_1.jsx)(DpTableDropdownFilter_1.DpTableDropdownFilter, { styles: "highlight-filter", options: options, selectHandler: filter })] }))] }));
};
exports.DpStudentsDetailsHeader = DpStudentsDetailsHeader;
exports.default = exports.DpStudentsDetailsHeader;
